import React from 'react';
import Banner from '../../Components/web/Banner';
import Videos from '../../Components/web/Videos';
import Paquetes from '../../Components/web/Paquetes';
import Sucursales from '../../Components/web/Sucursales';
import {Helmet} from 'react-helmet';
import './Principal.scss';

export default function Principal() {
    return (
        <>
        <Helmet>
            <title>Kids club | Salón de fiestas infantiles | Eventos infantiles</title>
            <meta name='description' content='Los mejores eventos infantiles, solo los tendrás en kids club, contamos con lugares con distintas temáticas, para que tus pequeños se diviertan a lo grande.'  data-react-helmet="true"/>
        </Helmet>
            <Banner/> 
            <Videos/>
           {/*  <Paquetes/> */}
            <Sucursales/>
        </>
    )
}
